import React from 'react';
import { LoaiVatTuAccount } from '../hooks/useSearchFieldStates';
import { QUERY_KEYS, taiKhoanSearchColumns } from '@/constants';
import { SearchField } from '@/components/custom/erp';
import { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface AccountTabProps {
  formMode: 'add' | 'edit' | 'view';
  warehouseAccount?: LoaiVatTuAccount | null;
  setWarehouseAccount?: (account: AccountModel) => void;
  revenueAccount?: LoaiVatTuAccount | null;
  setRevenueAccount?: (account: AccountModel) => void;
  costAccount?: LoaiVatTuAccount | null;
  setCostAccount?: (account: AccountModel) => void;
  discountAccount?: LoaiVatTuAccount | null;
  setDiscountAccount?: (account: AccountModel) => void;
  promotionAccount?: LoaiVatTuAccount | null;
  setPromotionAccount?: (account: AccountModel) => void;
  returnAccount?: LoaiVatTuAccount | null;
  setReturnAccount?: (account: AccountModel) => void;
  wipAccount?: LoaiVatTuAccount | null;
  setWipAccount?: (account: AccountModel) => void;
  materialAccount?: LoaiVatTuAccount | null;
  setMaterialAccount?: (account: AccountModel) => void;
}

export const AccountTab: React.FC<AccountTabProps> = ({
  formMode,
  warehouseAccount = null,
  setWarehouseAccount = () => {},
  revenueAccount = null,
  setRevenueAccount = () => {},
  costAccount = null,
  setCostAccount = () => {},
  discountAccount = null,
  setDiscountAccount = () => {},
  promotionAccount = null,
  setPromotionAccount = () => {},
  returnAccount = null,
  setReturnAccount = () => {},
  wipAccount = null,
  setWipAccount = () => {},
  materialAccount = null,
  setMaterialAccount = () => {}
}) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='space-y-2 p-4'>
      <div className='flex items-center'>
        <Label className='mt-3 min-w-44 font-medium'>Tk kho</Label>
        <SearchField
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          relatedFieldValue={warehouseAccount?.name || ''}
          value={warehouseAccount?.code || ''}
          disabled={isViewMode}
          onRowSelection={setWarehouseAccount}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-44 font-medium'>Tk doanh thu</Label>
        <SearchField
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          relatedFieldValue={revenueAccount?.name || ''}
          value={revenueAccount?.code || ''}
          disabled={isViewMode}
          onRowSelection={setRevenueAccount}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-44 font-medium'>Tk giá vốn</Label>
        <SearchField
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          relatedFieldValue={costAccount?.name || ''}
          value={costAccount?.code || ''}
          disabled={isViewMode}
          onRowSelection={setCostAccount}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-44 font-medium'>Tk chiết khấu</Label>
        <SearchField
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          relatedFieldValue={discountAccount?.name || ''}
          value={discountAccount?.code || ''}
          disabled={isViewMode}
          onRowSelection={setDiscountAccount}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-44 font-medium'>Tk khuyến mãi</Label>
        <SearchField
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          relatedFieldValue={promotionAccount?.name || ''}
          value={promotionAccount?.code || ''}
          disabled={isViewMode}
          onRowSelection={setPromotionAccount}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-44 font-medium'>Tk trả lại</Label>
        <SearchField
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          relatedFieldValue={returnAccount?.name || ''}
          value={returnAccount?.code || ''}
          disabled={isViewMode}
          onRowSelection={setReturnAccount}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-44 font-medium'>Tk sản phẩm dở dang</Label>
        <SearchField
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          relatedFieldValue={wipAccount?.name || ''}
          value={wipAccount?.code || ''}
          disabled={isViewMode}
          onRowSelection={setWipAccount}
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='mt-3 min-w-44 font-medium'>Tk chi phí NVL</Label>
        <SearchField
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          relatedFieldValue={materialAccount?.name || ''}
          value={materialAccount?.code || ''}
          disabled={isViewMode}
          onRowSelection={setMaterialAccount}
          className='w-100'
        />
      </div>
    </div>
  );
};
